
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Outstationcabsfrompune() {



    const cardData =
    {
        keyword: 'Outstation Cabs from Pune ',
        heading: 'S9 Travels: Outstation Cabs from Pune',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable outstation cab services from Pune to various destinations across Maharashtra and beyond. Whether you are planning a family vacation, a business trip, or a spiritual journey, our well-maintained fleet and professional drivers ensure a smooth and hassle-free experience. We provide both one-way and round-trip taxi services to a wide range of outstation destinations.',

        top: 'Popular Outstation Destinations from Pune with S9 Travels:',

        "topPlaces": [
            {
              "title": "Pune to Mumbai",
              "description": "Whether you're heading to Mumbai for business or leisure, S9 Travels provides a comfortable and convenient ride with our Mumbai-Pune outstation taxi services. The journey takes around 3-4 hours, and our experienced drivers ensure a safe and smooth ride."
            },
            {
              "title": "Pune to Lonavala",
              "description": "Lonavala is a popular hill station near Pune, known for its scenic landscapes, waterfalls, and pleasant climate. It's a great weekend getaway, just 2-3 hours away from Pune. Our cabs make the trip stress-free with top-notch amenities."
            },
            {
              "title": "Pune to Mahabaleshwar",
              "description": "Mahabaleshwar, a serene hill station with panoramic views, lush greenery, and misty weather, is about a 5-hour drive from Pune. Whether you're traveling for relaxation or adventure, we ensure your journey is comfortable and hassle-free."
            },
            {
              "title": "Pune to Shirdi",
              "description": "For spiritual travelers, Shirdi is a must-visit destination, home to the famous Sai Baba Temple. The journey takes around 5-6 hours from Pune, and our comfortable cabs ensure you travel peacefully."
            },
            {
              "title": "Pune to Alibaug",
              "description": "A beach lover's paradise, Alibaug is a coastal town just 3-4 hours away from Pune. It's a popular destination for beach resorts and a peaceful retreat. Enjoy a smooth ride to Alibaug with S9 Travels."
            },
            {
              "title": "Pune to Goa",
              "description": "The sunny beaches and vibrant culture of Goa are about 8-9 hours from Pune. Whether you're planning a relaxing vacation or a lively beach adventure, our outstation cabs to Goa provide you with the comfort and convenience you need."
            },
            {
              "title": "Pune to Nashik",
              "description": "Known for its vineyards, temples, and scenic beauty, Nashik is just a 4-hour drive from Pune. Our cabs will ensure you have a smooth and pleasant journey as you explore this historic city."
            },
            {
              "title": "Pune to Ratnagiri",
              "description": "A coastal town known for its stunning beaches and natural beauty, Ratnagiri is approximately a 6-7 hour drive from Pune. Travel comfortably with our outstation taxi services, perfect for a family or group trip."
            },
            {
              "title": "Pune to Aurangabad",
              "description": "A city rich in history and culture, Aurangabad is home to the famous Ajanta and Ellora caves. The city is around 6 hours from Pune, and our outstation cabs will take you there in comfort and style."
            },
            {
              "title": "Pune to Bhimashankar",
              "description": "A spiritual destination with the famous Bhimashankar Temple, this is a great retreat to connect with nature and spirituality. Bhimashankar is just 3-4 hours away from Pune, and we make your journey peaceful and enjoyable."
            }
          ],

"services": [
    {
      "name": "Pune Outstation Cab Booking",
      "description": "S9 Travels offers comfortable and reliable outstation cab booking services from Pune. Whether you're traveling to nearby cities or distant destinations, we ensure a smooth and hassle-free ride. Book your outstation cab from Pune today!"
    },
    {
      "name": "Outstation Cabs Pune",
      "description": "S9 Travels provides reliable outstation cab services from Pune to various destinations. Our fleet of well-maintained vehicles and professional drivers ensures a comfortable and enjoyable ride every time."
    },
    {
      "name": "Pune Outstation Taxi Service",
      "description": "Looking for a taxi service for an outstation trip from Pune? S9 Travels offers professional and dependable outstation taxi services to suit your travel needs. Whether you're traveling for business or leisure, we guarantee a smooth journey."
    },
    {
      "name": "Outstation Car Rentals from Pune",
      "description": "S9 Travels provides flexible and convenient outstation car rental services from Pune. Rent a car for your trip and travel at your own pace with our fleet of well-maintained vehicles and experienced drivers."
    },
    {
      "name": "Pune Outstation Taxi Fare",
      "description": "We offer affordable and transparent taxi fares for your outstation journey from Pune. With no hidden charges, S9 Travels ensures that you get the best value for your money. Contact us for an accurate fare estimate for your trip."
    },
    {
      "name": "Pune to Outstation Taxi Booking",
      "description": "Booking an outstation taxi from Pune is simple and convenient with S9 Travels. Whether you prefer booking online or by phone, we offer flexible booking options to suit your schedule. Book your taxi today for a smooth and hassle-free experience."
    },
    {
      "name": "Outstation Cab Service Pune",
      "description": "S9 Travels offers reliable and efficient outstation cab services from Pune to your preferred destinations. Our fleet of vehicles is well-maintained, and our drivers are experienced, ensuring a comfortable and safe journey every time."
    },
    {
      "name": "Outstation Taxi Booking Online from Pune",
      "description": "S9 Travels makes it easy to book outstation taxis online from Pune. With a simple booking process and quick confirmation, we ensure a hassle-free experience for your outstation trip. Book your outstation taxi online today!"
    },
    {
      "name": "Outstation Taxi Services Pune",
      "description": "Choose S9 Travels for professional and reliable outstation taxi services from Pune. We cater to a wide range of destinations and provide well-maintained vehicles with experienced drivers for a comfortable ride."
    },
    {
      "name": "Pune Outstation Car Hire",
      "description": "If you prefer to hire a car for your outstation trip from Pune, S9 Travels offers flexible and affordable options. Choose from our wide range of vehicles to suit your travel needs and enjoy a comfortable journey with our experienced drivers."
    },
    {
      "name": "Affordable Outstation Cabs from Pune",
      "description": "S9 Travels offers affordable outstation cab services from Pune, providing great value without compromising on comfort. Whether you’re going for a short or long-distance trip, our fares are designed to fit your budget."
    },
    {
      "name": "Pune to Goa Outstation Taxi",
      "description": "Looking for a taxi from Pune to Goa? S9 Travels offers reliable and comfortable outstation taxi services for your journey. Enjoy a smooth ride to Goa with our professional drivers and well-maintained vehicles."
    },
    {
      "name": "Pune to Mumbai Outstation Cabs",
      "description": "S9 Travels provides affordable and comfortable outstation cab services from Pune to Mumbai. Whether it’s a business trip or leisure travel, we ensure you have a relaxing journey to Mumbai with no hassle."
    },
    {
      "name": "Pune to Shirdi Outstation Cabs",
      "description": "Book an outstation cab with S9 Travels for your journey from Pune to Shirdi. Our well-maintained vehicles and professional drivers ensure a comfortable and timely trip to the famous Shirdi Sai Baba temple."
    },
    {
      "name": "Outstation Tour Packages from Pune",
      "description": "S9 Travels offers customized outstation tour packages from Pune to various destinations. Whether you're planning a spiritual, adventure, or leisure trip, our tour packages provide everything you need for a memorable journey."
    }
  ],


"tableData": [
  ["Pune Outstation Cab Booking", "Outstation Cabs Pune"],
  ["Pune Outstation Taxi Service", "Outstation Car Rentals from Pune"],
  ["Pune Outstation Taxi Fare", "Pune to Outstation Taxi Booking"],
  ["Outstation Cab Service Pune", "Outstation Taxi Booking Online from Pune"],
  ["Outstation Taxi Services Pune", "Pune Outstation Car Hire"],
  ["Affordable Outstation Cabs from Pune", "Pune to Goa Outstation Taxi"],
  ["Pune to Mumbai Outstation Cabs", "Pune to Shirdi Outstation Cabs"],
  ["Outstation Tour Packages from Pune", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of time when traveling outstation from Pune. Whether it's for business, leisure, or a family trip, our drivers ensure timely pickups and drop-offs, guaranteeing a hassle-free experience every time."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a wide range of comfortable vehicles for your outstation trip from Pune. Our fleet includes sedans, SUVs, and premium cars, all equipped with air conditioning, comfortable seating, and ample space for luggage, ensuring a smooth and enjoyable journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced and well-versed in handling long-distance travel. They know the best routes and ensure that you reach your destination safely and comfortably. Their professionalism and knowledge of the roads make your trip more enjoyable."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable and transparent pricing for your outstation journey from Pune. We provide a clear breakdown of the costs upfront with no hidden charges, so you can be sure of the total cost before you travel."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking to ensure a secure and comfortable ride, no matter how far your destination is."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels operates around the clock, meaning you can book an outstation cab at any time of the day or night. Whether you need an early morning departure or a late-night return, we are always ready to serve you."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your outstation cab from Pune is simple and convenient. You can easily book through our website or mobile app, or get in touch with our customer service team for assistance with your reservation."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages for your outstation trips, whether it’s for sightseeing, business, or a family vacation. Let us know your specific requirements, and we will tailor the trip to your needs."
  }
]




















    }



    const faqData = [
        [
          {
            question: 'How can I book an outstation cab from Pune with S9 Travels?',
            answer: 'Booking is easy! You can book online through our website or app, or contact our customer service team for personalized assistance with your booking.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, all our drivers are experienced in long-distance travel and familiar with the best routes to your outstation destination, ensuring a smooth and safe journey.',
          },
          {
            question: 'What types of vehicles are available for outstation travel from Pune?',
            answer: 'We offer a variety of vehicles for outstation trips, including sedans, SUVs, and premium cars. All of our vehicles are well-maintained, ensuring comfort and safety throughout the journey.',
          },
          {
            question: 'How do I pay for my outstation cab rental from Pune?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and online payments via our app, making the payment process convenient for you.',
          },
          {
            question: 'Can I book a round trip for my outstation cab?',
            answer: 'Yes, we can arrange round trips for your outstation travel. Just provide us with your return details, and we will handle everything to ensure a seamless experience.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges, such as for waiting time or detours, will be clearly communicated to you upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing during my outstation trip?',
            answer: 'Yes, we offer sightseeing services as part of your outstation journey. Explore local attractions and points of interest with the guidance of our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for an outstation cab from Pune?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have more luggage or special requirements, please let us know during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel outstation from Pune?',
            answer: 'Yes, we provide corporate travel services for business-related outstation trips. Whether it’s for meetings or group travel, we ensure punctual, professional, and reliable service.',
          },
          {
            question: 'Why should I choose S9 Travels for my outstation trip from Pune?',
            answer: 'S9 Travels guarantees a comfortable, reliable, and affordable outstation journey with professional drivers, well-maintained vehicles, and excellent customer service. You can rely on us for a smooth and stress-free trip to any destination from Pune.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Sanjay Rao',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked an outstation cab from Pune to Lonavala with S9 Travels. The driver was professional, the vehicle was clean and comfortable, and the whole trip was smooth. I will definitely book again.”',
        },
        {
          name: 'Mrs. Priya Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family took an outstation trip from Pune to Mahabaleshwar with S9 Travels. The experience was great! The car was spacious, and the driver was knowledgeable about the area. A very comfortable journey!”',
        },
      ];
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "Outstation Cabs From Pune",
      "description": "Book outstation cabs from Pune for your travel needs. Whether it’s a one-way or round-trip taxi, or outstation car rental, S9 Travels provides affordable and reliable Pune outstation taxi services to popular destinations like Goa, Mumbai, Shirdi, and more.",
      "aggregateRating": {
        "@type": "AggregateRating",
        "bestRating": "5",
        "worstRating": "1",
        "ratingValue": "4.8",
        "ratingCount": "8569"
      }
    };
    

      
      


    return (
        <div>
             <Helmet>
      <title>Outstation Cabs From Pune | S9 Travels | Contact: +91 8850328441</title>
      <meta 
        name="description" 
        content="Book outstation cabs from Pune for one-way or round-trip taxi services, car rentals, and more. Get affordable fares for Pune to outstation travel to Goa, Mumbai, Shirdi, and other destinations with S9 Travels." 
      />
      
      {/* Inject JSON-LD Schema */}
      <script type="application/ld+json">
        {JSON.stringify(productSchema)}
      </script>
    </Helmet>
    
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/17.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Outstationcabsfrompune;